import {Component, effect, forwardRef, input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-select-option',
  imports: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectOptionComponent),
      multi: true,
    }
  ],
  templateUrl: './select-option.component.html',
  styleUrl: './select-option.component.scss'
})
export class SelectOptionComponent implements ControlValueAccessor {
  options = input.required<{ name: string; }[]>();
  label = input.required<string>();
  showAsteric = input<boolean>(false);

  value = '';
  disabled = false;
  onChange = (_: any) => {};
  onTouched = () => {};

  constructor() {
    // When options change, ensure the current value is still valid
    effect(() => {
      const opts = this.options();
      if (this.value && opts.length > 0) {
        // Check if current value exists in options
        const valueExists = opts.some(opt => opt.name === this.value);
        if (!valueExists) {
          // Value doesn't exist in options, reset it
          this.value = '';
          this.onChange('');
        }
      }
    });
  }

  writeValue(value: string): void {
    this.value = value || '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleChange(event: Event) {
    const select = event.target as HTMLSelectElement;
    this.value = select.value;
    this.onChange(this.value);
  }
}
